'use client';

import { useRef, useState } from 'react';
import type { MutableRefObject } from 'react';

export function useReactiveRef<T>(initialValue: T): MutableRefObject<T> {
  const valueRef = useRef(initialValue);
  const [, forceRender] = useState(0);
  const reactiveRef = useRef<MutableRefObject<T> | null>(null);

  if (!reactiveRef.current) {
    const ref = {} as MutableRefObject<T>;
    Object.defineProperty(ref, 'current', {
      get: () => valueRef.current,
      set: (nextValue: T) => {
        if (Object.is(valueRef.current, nextValue)) return;
        valueRef.current = nextValue;
        forceRender((version) => version + 1);
      },
      enumerable: true,
    });
    reactiveRef.current = ref;
  }

  return reactiveRef.current;
}
